import * as types from '../../../actions/actiontypes';
import * as actionTypes from '../../../components/Common/HandOff/Actions/actiontypes';
import initialstate from '../../initialstate';

export default function reloadDataBannerReducer(state = initialstate.reloadDataBanner, action) {
	switch (action.type) {
		case types.RESET_RELOAD_DATA_FLAG_FOR_PIC_EQR_DASHBOARD:
			return {...state, isReloadRequired: false};

		case types.START_LISTENING_TO_CHANGES_ON_TASK_DRAWER:
			return {...state, isDrawerOpen: true};

		case types.STOP_LISTENING_TO_CHANGES_ON_TASK_DRAWER:
			return {...state, isDrawerOpen: false};

		case types.EDIT_TASK_TITLE:
		case types.CHANGE_TASK_STATUS:
		case types.DELETE_TASKS:

		case types.UPDATE_EQR_SIGNOFF_USER_REQUIRED:
		case types.UPDATE_EP_EQR_SIGNOFF_INFO:

		case types.CHANGE_TASK_ASSIGNMENT_STATUS:
		case types.CREATE_TASK_ASSIGNMENT:
		case types.EDIT_TASK_ASSIGNMENTS:
		case types.DELETE_TASK_ASSIGNMENT:
		case types.UPDATE_TASK_TIME_PHASES:
		case types.UPDATE_ASSIGNMENTS_TIME_PHASE:
		case types.UPDATE_DUE_DATE:

		case types.ASSOCIATE_TASK_DOCUMENTS:
		case types.ADD_DOCUMENTS_TO_TASKS:
		case types.ADD_APPROVAL_FOR_DOCUMENT:
		case types.REMOVE_APPROVAL_FOR_DOCUMENT:
		case types.UPDATE_DOCUMENT:
		case types.UPDATE_TASK_DOCUMENT_RELATE:
		case types.DELETE_DOCUMENT_BY_ID:

		case types.SET_TASK_BOOKMARK:

		case types.ASSOCIATE_TASK_TAG:
		case types.UPDATE_TAG:
		case types.REMOVE_TASK_TAGS:

		case types.POST_RNH_NEW_NOTE:
		case types.UPDATE_RNH_NOTE_DETAIL:
		case types.DELETE_RNH_PARENT_NOTE:

		case actionTypes.HO_APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS:
		case actionTypes.HO_CREATE_TASK_ASSIGNMENT:
		case actionTypes.HO_EDIT_TASK_ASSIGNMENTS:

		case types.SEND_CUSTOM_CLIENT_REQUEST:

		case types.Add_RELATED_REQUEST:
			const tempState = _.cloneDeep(state);
			if (state.isDrawerOpen) {
				tempState.isReloadRequired = true;
			}
			return tempState;

		default:
			return state;
	}
}
